"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["color", "size", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RecurrenceIcon = function RecurrenceIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M2.734 5.879a2.71 2.71 0 0 0-.276 3.345 1.06 1.06 0 0 0 .094.128l-.755.656a2.145 2.145 0 0 1-.177-.24 3.68 3.68 0 0 1 .407-4.596A3.971 3.971 0 0 1 4.855 4h6.165l-1.6-1.602.707-.707L12.935 4.5l-2.809 2.809-.707-.707L11.021 5H4.856a2.981 2.981 0 0 0-2.122.879zm11.657.352a1.933 1.933 0 0 0-.175-.237l-.759.652a1.097 1.097 0 0 1 .095.13 2.71 2.71 0 0 1-.275 3.345 2.981 2.981 0 0 1-2.122.879H4.98l1.602-1.602-.707-.707-2.81 2.809 2.809 2.809.707-.707L4.979 12h6.176a3.971 3.971 0 0 0 2.829-1.172 3.8 3.8 0 0 0 .407-4.597z"
    }));
  }

  if (size <= 24) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.922 16.71l-.651.758a6.832 6.832 0 0 1-2.07-4.983A6.372 6.372 0 0 1 8.585 6h7.454L14.4 4.36l.706-.708L17.954 6.5l-2.848 2.848-.707-.707L16.04 7H8.586A5.386 5.386 0 0 0 3.2 12.5a5.92 5.92 0 0 0 1.722 4.21zm14.8-9.178l-.652.758a5.944 5.944 0 0 1 1.73 4.21 5.39 5.39 0 0 1-5.395 5.5H7.96l1.64-1.64-.706-.708L6.046 18.5l2.848 2.848.707-.707L7.96 19h7.445a6.376 6.376 0 0 0 6.395-6.486 6.857 6.857 0 0 0-2.079-4.982z"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.554 22.016l-.522.853A8.26 8.26 0 0 1 3.2 15.877 7.874 7.874 0 0 1 11.054 8h9.989l-2.647-2.646.707-.707L22.957 8.5l-3.854 3.854-.707-.707L21.043 9h-9.989A6.873 6.873 0 0 0 4.2 15.877a7.24 7.24 0 0 0 3.354 6.139zM24.964 9.13l-.522.853a7.242 7.242 0 0 1 3.358 6.14A6.875 6.875 0 0 1 20.942 23h-9.985l2.646-2.646-.707-.707L9.043 23.5l3.854 3.854.707-.707L10.957 24h9.985a7.876 7.876 0 0 0 7.858-7.877 8.264 8.264 0 0 0-3.836-6.992z"
  }));
};

var _default = RecurrenceIcon;
exports["default"] = _default;